export const LOGIN_URL = '/login';
export const ERROR404_URL = '/404';
export const ERROR409_URL = '/409';
export const ERROR500_URL = '/500';

export const CLIENTS_PAGE_TITLE = 'クライアント管理';
export const CLIENTS_URL = '/clients';
export const CLIENT_DETAIL_PAGE_TITLE = (name: string) => `クライアント詳細_${name}`;
export const CLIENT_DETAIL_URL = (id: string) => `/clients/${id}`;

export const USER_LIST_PAGE_TITLE = 'ユーザー管理';
export const USER_LIST_URL = '/users';
export const USER_PROFILE_URL = (id: string) => `/users/${id}`;

export const RESERVATIONS_LIST_PAGE_TITLE = '予約管理';
export const RESERVATION_LIST_URL = '/reservations';

export const RESERVATION_DETAIL_SECTION_TITLE = '予約詳細情報：';
export const RESERVATION_DETAIL_URL = (reservationNo: string) => `/reservations/${reservationNo}`;

export const FEE_URL = (reservationNo: string, reservationId: number, corporationId: string) =>
  `${RESERVATION_LIST_URL}/${reservationNo}/fee?reservationId=${reservationId}&corporationId=${corporationId}`;

export const SUM_BILLING_TITLE = '請求関連';
export const SUM_BILLING_URL = '/billing';
